export const CONNECTED = 'CONNECTED';